import React, { useState } from 'react';
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useForm } from "react-hook-form";
import Switch from "react-bootstrap-switch";

import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";

export default function WebCamFilters(props) {
    const [status, setStatus] = useState(null)
    const { register, handleSubmit, reset } = useForm();

    const onSubmit = (data, _) => {
        const dataFilter = {
            ...data,
            status : status
        };

        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setStatus(null);
        reset();
    }

    return (<Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col>
                    <FormGroup>
                        <Label>Código</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder="Búsqueda por código"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>Nombre</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder="Búsqueda por código"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>Activo</Label>
                        <br/>
                        <Switch 
                            animate={true} 
                            offText={"No"} 
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <ButtonSearch />
                    <ButtonClean onClick={() => cleanFields()} />
                </Col>
            </Row>
        </CardBody>
    </Form>);
}